var _Path, _Path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Path } from "react-native-svg";
var SvgCatBackgroundActive = function SvgCatBackgroundActive(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    overflow: "visible",
    preserveAspectRatio: "none",
    style: {
      display: "block"
    },
    viewBox: "0 0 24 24"
  }, props), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    stroke: "#FF9",
    strokeWidth: 2,
    d: "M19 4H5a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2Z"
  })), _Path2 || (_Path2 = /*#__PURE__*/React.createElement(Path, {
    fill: "#FF9",
    d: "M8 11a2 2 0 1 0 0-4 2 2 0 0 0 0 4M5.414 18c-.89 0-1.337-1.077-.707-1.707l3.586-3.586a1 1 0 0 1 1.414 0l2.586 2.586a1 1 0 0 0 1.414 0l1.503-1.503a1 1 0 0 1 1.488.082l2.002 2.503A1 1 0 0 1 17.92 18z"
  })));
};
export default SvgCatBackgroundActive;